import React from 'react';
import { Box } from '@mui/material';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';
import GuaranteesApplicationFilesBlock from '../../../shared/components/ApplicationFiles/GuaranteesApplicationFilesBlock.tsx';
import GuaranteesApplicationStatusFlow from '../../../shared/components/StatusFlow/GuaranteesApplicationStatusFlow.tsx';
import type { IGuaranteesManagerApplicationSidePanelProps } from './types.ts';

const GuaranteesManagerApplicationSidePanel: React.FC<
  IGuaranteesManagerApplicationSidePanelProps
> = ({ filesBlockProps, statusFlowProps }) => (
  <Box sx={guaranteesClientPageStyles.applicationSidePanelStack}>
    <GuaranteesApplicationFilesBlock {...filesBlockProps} />
    <GuaranteesApplicationStatusFlow {...statusFlowProps} />
  </Box>
);

export default GuaranteesManagerApplicationSidePanel;
